import { fetchEventSource } from "@microsoft/fetch-event-source";
import { Article } from "@mui/icons-material";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SaveIcon from "@mui/icons-material/SaveOutlined";
import StopCircle from "@mui/icons-material/StopCircle";
import {
  Box,
  Button,
  DialogContent,
  DialogContentText,
  FormControl,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Skeleton from "@mui/material/Skeleton";
import axios from "axios";
import { signOut } from "firebase/auth";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Greenbanner from "../header/greenbanner";
import "./chatpage.css";

import { auth } from "../../auth/firebase-config";
import { UseSnackbar } from "../snackbar/snackbarContext";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";

import Footer from "./footer";
import PDFViewer from "./pdf-viewer-iframe";
import ChatContainer from "./prompts";
import DTable from "./table";
import Spinner from "./Spinner";

import {
  deleteMessage,
  updateMessageResponseTime,
} from "@/api/message/message.api";
import useParentStore from "@/store/parent-store";
import { createCitations } from "@/utils/util";

const Generate_Parent = () => {
  function LinearColor() {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          width: "inherit",
          height: "inherit",
        }}
      >
        <b className="blinking">{loadtext}</b>
        <Skeleton variant="rounded" height={60} sx={{ width: "inherit" }} />
        <Box sx={{ display: "flex", gap: "0.8rem", width: "inherit" }}>
          <Skeleton variant="rounded" width={300} height={100} />
          <Skeleton variant="rounded" width={400} height={100} />
          <Skeleton variant="rounded" width={300} height={100} />
        </Box>
        <Box sx={{ display: "flex", gap: "0.8rem", width: "inherit" }}>
          <Skeleton variant="rounded" width={300} height={90} />
          <Skeleton variant="rounded" width={400} height={90} />
          <Skeleton variant="rounded" width={300} height={90} />
        </Box>
        <Box sx={{ display: "flex", gap: "0.8rem", width: "inherit" }}>
          <Skeleton variant="rounded" width={300} height={80} />
          <Skeleton variant="rounded" width={400} height={80} />
          <Skeleton variant="rounded" width={300} height={80} />
        </Box>
        <Box sx={{ display: "flex", gap: "0.8rem", width: "inherit" }}>
          <Skeleton variant="rounded" width={300} height={70} />
          <Skeleton variant="rounded" width={400} height={70} />
          <Skeleton variant="rounded" width={300} height={70} />
        </Box>
        <Box sx={{ display: "flex", gap: "0.8rem", width: "inherit" }}>
          <Skeleton variant="rounded" width={300} height={70} />
          <Skeleton variant="rounded" width={400} height={70} />
          <Skeleton variant="rounded" width={300} height={70} />
        </Box>
        <Box sx={{ display: "flex", gap: "0.8rem", width: "inherit" }}>
          <Skeleton variant="rounded" width={300} height={70} />
          <Skeleton variant="rounded" width={400} height={70} />
          <Skeleton variant="rounded" width={300} height={70} />
        </Box>
      </Box>
    );
  }

  const ApiErrorDisplay = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "55vh",
          textAlign: "center",
        }}
      >
        <Typography variant="h5" sx={{ marginBottom: "16px" }}>
          Sorry, something went wrong while processing your request. Please try
          again.
        </Typography>
      </Box>
    );
  };

  function Msgloader() {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          width: "inherit",
          height: "inherit",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "inherit",
          }}
        ></Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "inherit",
          }}
        >
          <Skeleton
            animation="wave"
            variant="rounded"
            width={300}
            height={100}
            sx={{ alignSelf: "flex-start", ml: "10px" }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "inherit",
          }}
        >
          <div sx={{ alignSelf: "flex-start" }} />
          <Skeleton
            animation="wave"
            variant="rounded"
            width={400}
            height={100}
            sx={{ alignSelf: "flex-end", mr: "10px" }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "inherit",
          }}
        >
          <Skeleton
            animation="wave"
            variant="rounded"
            width={300}
            height={100}
            sx={{ alignSelf: "flex-start", ml: "10px" }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "inherit",
          }}
        >
          <div sx={{ alignSelf: "flex-start" }} />
          <Skeleton
            animation="wave"
            variant="rounded"
            width={400}
            height={100}
            sx={{ alignSelf: "flex-end", mr: "10px" }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "inherit",
          }}
        >
          <Skeleton
            animation="wave"
            variant="rounded"
            width={350}
            height={80}
            sx={{ alignSelf: "flex-start", ml: "10px" }}
          />
        </Box>
      </Box>
    );
  }
  const [showButtons, setshowButtons] = useState(false);
  const [parentgenerate, setparentgenerate] = useState(false);
  const [question, setQuestion] = useState("");
  const [conversation_id, setConversation_id] = useState(null);
  const [gcs_generated_documents, setGcs_generated_documents] = useState(null);
  const showSnackbar = UseSnackbar();
  const [loadtext, setloadtext] = useState(
    "Please wait response is being generated..."
  );
  const [msgloadtext, setmsgloadtext] = useState("Generating");
  const [citations, setCitations] = useState(null);

  const [loadversion, setloadversion] = useState(false);
  const sendquestion = (event: any) => {
    setQuestion(event.target.value);
  };

  const [isEditable, setIsEditable] = useState(false);
  const [save_dashboard, setsave_dashboard] = useState(false);
  const [isApiError, setIsApiError] = useState(false);
  const [isTimeoutError, setIsTimeoutError] = useState(false);

  const handleEditClick = () => {
    setIsEditable(!isEditable);
  };

  const location = useLocation();
  const [chat_data, setchat_data] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [messages, setmessages] = useState<any>([]);
  const [timeoutPopUp, setTimeOutPopUp] = useState(false);
  const value = location.state?.transformedResponse;
  const navigate = useNavigate();
  const [document_name, setdocument_name] = useState("");
  const [version, setVersion] = useState(0);
  const [user_edit, setuser_edit] = useState(false);
  const [userStop, setUserStop] = useState(false);
  const [editGeneration, setEditGeneration] = useState(false);
  const [stopMessageId, setStopMessageId] = useState("");
  const [responseTime, setResponseTime] = useState(null);

  const abortControllerRef = useRef<AbortController>(undefined);
  const callDoneRef = useRef<boolean>(undefined);

  const ParentStore = useParentStore();

  const hasFetchedData = useRef(false);
  const [elapsedTime, setElapsedTime] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const firstdata = async () => {
      if (value.conversation_id === "") {
        if (!hasFetchedData.current) {
          // Check if API has already been called
          fetchData(value);
          hasFetchedData.current = true; // Set the flag to true after the first call
        }
      } else {
        setConversation_id(value.conversation_id);
        setuser_edit(value.user_disabled);
        try {
          const docs = await getall_docs(value.conversation_id);
          // console.log('Fetched docs:', docs);
          setalldocs(docs.data.data.Documents);
          const document_version_data = await document_iddata(
            value.document_id
          );
          // console.log(document_version_data)
          setGcs_generated_documents(document_version_data.data.doc_url);
          setVersion(document_version_data.data.document_version);
          setdocument_name(document_version_data.data.document_name);
          const document_version_content = await fetch_gcsdata(
            document_version_data.data.doc_url
          );
          setchat_data(document_version_content.content);
          getall_msg(value.conversation_id)
            .then(async (allmsg) => {
              const messages = allmsg.data.data;
              const parsedMessages = messages
                ?.filter((msg) => msg.to_display)
                .map((msg, index) => {
                  let displayName = "";
                  if (msg.message_type === "User") {
                    displayName = "userprompt";
                  } else if (msg.message_type === "System") {
                    displayName = "response";
                    console.log(msg?.data?.SourceFiles);
                  }
                  if (index == 0) {
                    setCitations(createCitations(msg?.data?.SourceFiles));
                  }
                  return {
                    message: msg.data.content.replace(/\\n/g, "\n"),
                    displayName,
                    citations: createCitations(msg?.data?.SourceFiles),
                    responseTime: msg?.response_time,
                    messageId: msg?.id,
                  };
                });
              setmessages(parsedMessages);
            })
            .catch((error) => {
              console.error("Error fetching messages:", error);
            });
        } catch (error) {
          console.error("Error fetching documents:", error);
        }
      }
      if (value.section === "Requirements") {
        setshowButtons(true);
      }
      if (value.section === "parent_generation") {
        setparentgenerate(true);
      }
    };
    firstdata();
  }, [value]);

  const fetchData = async (value) => {
    setElapsedTime(0);
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    timerRef.current = setInterval(() => {
      setElapsedTime((prevElapsedTime) => prevElapsedTime + 1);
    }, 1000);
    abortControllerRef.current = new AbortController();
    if (callDoneRef) callDoneRef.current = false;
    let timer = value.section == "Traceability" ? 720 : 1200;
    const timeoutPromise = new Promise((resolve) => {
      setTimeout(() => {
        resolve("timeout");
      }, timer * 1000);
    });
    const accessToken = localStorage.getItem("accessToken");
    setIsApiError(() => false);
    const startTime = Date.now();
    const responsePromise = Promise.race([
      fetchEventSource(`${import.meta.env.VITE_API_URL}/chat-stream`, {
        openWhenHidden: true,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
          Authorization: `Bearer ${accessToken}`,
        },
        signal: abortControllerRef?.current?.signal,
        body: JSON.stringify(value),
        async onopen(response) {
          if (response.ok) {
            return; // everything's good
          } else if (
            response.status >= 400 &&
            response.status < 500 &&
            response.status !== 429
          ) {
            if (response.status === 401) {
              signOut(auth)
                .then(() => {
                  localStorage.removeItem("userInfo");
                  localStorage.removeItem("accessToken");
                  localStorage.removeItem("user_data");
                  console.log("User signed out due to inactivity.");
                })
                .catch((signOutError) => {
                  console.error("Error signing out:", signOutError);
                });
            } else {
              showSnackbar("Something Went Wrong! Please Refresh! ", "error");
              setIsApiError(() => true);
            }
          } else {
            showSnackbar("Something Went Wrong! Please Refresh! ", "error");
          }
        },
        async onmessage(msg) {
          if (msg.data === "timeout") {
            return;
          }
          const parsed_data = JSON.parse(msg.data);
          if (parsed_data?.data?.status) {
            setloadtext(parsed_data?.data?.status);
            return; // If it's just a status update, return early
          }

          // Process the response data
          if (parsed_data?.data?.response) {
            setConversation_id(parsed_data?.data?.conversation_id);
            setGcs_generated_documents(
              parsed_data?.data?.gcs_generated_documents
            );
            setchat_data(JSON.stringify(parsed_data?.data?.response));
            const endTime = Date.now();
            const responseTime = endTime - startTime;
            setResponseTime(responseTime);
            if (timerRef.current) {
              clearInterval(timerRef.current);
              timerRef.current = null;
            }
            saveResponseTime(parsed_data?.data?.message_id, responseTime);
            setmessages((prevMessages) => [
              ...prevMessages,
              {
                message: parsed_data?.data?.response,
                displayName: "response",
                citations: createCitations(parsed_data?.data?.SourceFiles),
                responseTime,
                messageId: parsed_data.data.message_id,
              },
            ]);
            setCitations(createCitations(parsed_data?.data?.SourceFiles));

            // Fetch all documents and handle them
            const res = await getall_docs(parsed_data?.data?.conversation_id);
            handlealldocs(res.data.data.Documents);
          }
        },
      }),
      timeoutPromise,
    ]);

    try {
      const response = await responsePromise;
      if (response === "timeout") {
        setIsApiError(() => true);
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
        setmessages((prevMessages: any) => [
          ...prevMessages,
          {
            messageId: "fallback",
            message:
              "Sorry, something went wrong while processing your request. Please try again.",
            displayName: "response",
          },
        ]);
        // Cancel the API call
        abortControllerRef.current.abort();
      }
    } catch (error) {
      setIsApiError(() => true);
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      setmessages((prevMessages: any) => [
        ...prevMessages,
        {
          messageId: "fallback",
          message: "An error occurred. Please try again later.",
          displayName: "response",
        },
      ]);
    }
  };

  const secondcall = async (value: any) => {
    abortControllerRef.current = new AbortController();
    if (callDoneRef) callDoneRef.current = false;
    setIsTimeoutError(false);
    setStopMessageId("");
    let timer = value.section == "Traceability" ? 720 : 1200;
    const timeoutPromise = new Promise((resolve) => {
      setTimeout(() => {
        resolve("timeout");
      }, timer * 1000);
    });

    const accessToken = localStorage.getItem("accessToken");
    const startTime = Date.now();
    const responsePromise = Promise.race([
      fetchEventSource(`${import.meta.env.VITE_API_URL}/chat-stream`, {
        openWhenHidden: true,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/event-stream",
          Authorization: `Bearer ${accessToken}`,
        },
        signal: abortControllerRef?.current?.signal,
        body: JSON.stringify(value),
        async onopen(response) {
          if (response.ok) {
            return;
          } else if (
            response.status >= 400 &&
            response.status < 500 &&
            response.status !== 429
          ) {
            if (response.status === 401) {
              signOut(auth)
                .then(() => {
                  localStorage.removeItem("userInfo");
                  localStorage.removeItem("accessToken");
                  localStorage.removeItem("user_data");
                })
                .catch((signOutError) => {});
            } else {
              showSnackbar("Something Went Wrong! Please Try Again! ", "error");
            }
          } else {
            showSnackbar("Something Went Wrong! Please Try Again! ", "error");
          }
        },
        onmessage(msg) {
          if (msg.data === "timeout") {
            setIsTimeoutError(true);
            return;
          }
          try {
            const parsed_data = JSON.parse(msg.data);

            if (parsed_data?.internal_event) {
              ParentStore?.setStopMessageId(
                parsed_data?.internal_event?.message_id
              );
              setStopMessageId(parsed_data?.internal_event?.message_id);
            }

            if (parsed_data?.data?.status) {
              setmsgloadtext(parsed_data.data.status);
              return;
            }

            if (parsed_data?.data?.response) {
              if (callDoneRef?.current === false) callDoneRef.current = true;
              setLoading(false);
              setEditGeneration(false);
              ParentStore?.setStopMessageId("");
              const endTime = Date.now();
              const responseTime = endTime - startTime;
              saveResponseTime(parsed_data?.data?.message_id, responseTime);
              setmessages((prevMessages: any) => [
                ...prevMessages,
                {
                  message: parsed_data.data.response?.replace(/\\n/g, "\n"),
                  displayName: "response",
                  citations: createCitations(parsed_data?.data?.SourceFiles),
                  responseTime,
                  messageId: parsed_data.data.message_id,
                },
              ]);
            }
          } catch (error) {
            showSnackbar("Error processing server response", "error");
          }
        },
      }),
      timeoutPromise,
    ]);

    try {
      const response = await responsePromise;
      if (response === "timeout") {
        setIsTimeoutError(true);
        setmessages((prevMessages: any) => [
          ...prevMessages,
          {
            messageId: "fallback",
            message:
              "Sorry, something went wrong while processing your request. Please try again.",
            displayName: "response",
          },
        ]);
        // Cancel the API call
        abortControllerRef.current.abort();
        setLoading(false);
        setEditGeneration(false);
      }
    } catch (error) {
      setIsTimeoutError(true);
      console.error("Error during API call:", error);
      setmessages((prevMessages: any) => [
        ...prevMessages,
        {
          messageId: "fallback",
          message: "An error occurred. Please try again later.",
          displayName: "response",
        },
      ]);
      setLoading(false);
      setEditGeneration(false);
    }
  };

  const getall_docs = async (conversationId) => {
    const accessToken = localStorage.getItem("accessToken");
    const skip = 0;
    const limit = 0;
    const API_URL = `${
      import.meta.env.VITE_API_URL
    }/documents_on_conversation/${conversationId}?skip=${skip}&limit=${limit}`;

    try {
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Trigger signOut if 401 Unauthorized is received
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Refresh! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  const handleTimeoutPopUpClose = () => {
    setTimeOutPopUp(false);
  };
  const handleuserinput = async () => {
    setLoading(true);
    setEditGeneration(true);
    setmessages((prevMessages: any) => [
      ...prevMessages,
      { message: question, displayName: "userprompt" },
    ]);

    value["process"] = "resume";
    value["message"] = question;
    value["conversation_id"] = conversation_id;
    value["version_uri"] = gcs_generated_documents;
    value["attachments"] = {
      additional_files: [],
    };
    value["source_ids"] = [];
    try {
      await secondcall(value);
    } catch (error) {
      console.error("Error during second call:", error);
    } finally {
    }
    setQuestion("");
  };

  useEffect(() => {}, [messages]);

  const handlesetchat = (newchat) => {
    setchat_data(newchat);
  };

  const handlealldocs = (docs) => {
    setalldocs(docs);
  };

  useEffect(() => {}, [chat_data]);
  useEffect(() => {}, [document_name]);
  useEffect(() => {}, [version]);

  useEffect(() => {}, [loading]);

  const savedocfirebase = async (gcs_url, incrementedVersion) => {
    const API_URL = `${import.meta.env.VITE_API_URL}/Document`;
    const accessToken = localStorage.getItem("accessToken");
    const user_data = localStorage.getItem("user_data");
    const documentData = {
      conversations_id: conversation_id,
      doc_url: gcs_url,
      document_name: "",
      document_version: incrementedVersion,
      project_name: value.project_name,
      type: getParentLabel(value.section),
      user_id: JSON.parse(user_data).id,
      feedback: 1,
      response_time: responseTime,
    };
    try {
      const response = await axios.post(API_URL, documentData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response && response.status === 200) {
        showSnackbar("Document new version created", "success");
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Trigger signOut if 401 Unauthorized is received
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Try again! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  const handleSaveVersion = async () => {
    const API_URL = `${import.meta.env.VITE_API_URL}/upload-attachment`;
    const chatdata = chat_data;
    var gcs_url = "";
    const accessToken = localStorage.getItem("accessToken");
    const file = new File([chatdata], "save.txt", { type: "text/plain" });
    const formData = new FormData();
    formData.append(`files`, file);
    try {
      const response = await axios.post(API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response) {
        gcs_url = response.data.data[0];
      } else {
        throw new Error("Invalid response format");
      }
      return response;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Trigger signOut if 401 Unauthorized is received
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Try again! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  const uniqueSectionParentPairs = [
    { section: "Needs", parentLabel: "Feature Needs with Rationale" },
    { section: "Usecases", parentLabel: "Use cases" },
    {
      section: "Requirements",
      parentLabel: "Feature Requirements with Rationale",
    },
    { section: "User_stories", parentLabel: "User Stories" },
    { section: "test_case_steps", parentLabel: "Test Case Steps" },
    {
      section: "Expected_results",
      parentLabel: "Acceptance Criteria & Expected Results",
    },
    { section: "parent_generation", parentLabel: "System Requirements" },
    { section: "Traceability", parentLabel: "End to End Traceability" },
  ];

  const getParentLabel = (section) => {
    const found = uniqueSectionParentPairs.find(
      (item) => item.section === section
    );
    return found ? found.parentLabel : null;
  };

  const [alldocs, setalldocs] = useState([]);
  const [covloader, setcovloader] = useState(false);

  useEffect(() => {}, [covloader]);

  const handleSave = async () => {
    setloadversion(true);
    try {
      // Wait for handleSaveVersion to complete
      const response = await handleSaveVersion();

      // Call getall_docs after handleSaveVersion completes
      const res = await getall_docs(conversation_id);
      const resdata = res.data.data.Documents;
      const extractedData = resdata.map((doc) => ({
        gcs_url: doc.doc_url,
        document_version: doc.document_version,
      }));
      const sortedData = extractedData.sort(
        (a, b) => b.document_version - a.document_version
      );

      if (sortedData.length > 0) {
        const highestVersion = sortedData[0].document_version;
        const incrementedVersion = (highestVersion + 0.1).toFixed(1);
        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.length > 0
        ) {
          const gcs_url = response.data.data[0];
          setVersion(incrementedVersion);
          setGcs_generated_documents(gcs_url);
          await savedocfirebase(gcs_url, incrementedVersion);
          const res = await getall_docs(conversation_id);
          handlealldocs(res.data.data.Documents);
        } else {
          throw new Error("Invalid response format from handleSaveVersion");
        }
      }
    } catch (error) {
      showSnackbar("Error during save operation", "error");
    } finally {
      setloadversion(false);
    }
  };
  function handlesavedashboard() {
    if (!save_dashboard && !user_edit) {
      setOpen(true);
    } else {
      navigate("/dashboard");
    }
  }
  const handleClose = () => {
    setOpen(false);
  };
  const handledialog = () => {
    setOpen(false);
    navigate("/dashboard");
  };
  const fetch_gcsdata = async (gcsurl) => {
    const accessToken = localStorage.getItem("accessToken");
    const API_URL = `${
      import.meta.env.VITE_API_URL
    }/get-file-content?file_path=${encodeURIComponent(gcsurl)}`;

    try {
      const response = await axios.post(API_URL, null, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Trigger signOut if 401 Unauthorized is received
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Refresh! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };
  const document_iddata = async (doc_id) => {
    const accessToken = localStorage.getItem("accessToken");
    const API_URL = `${import.meta.env.VITE_API_URL}/Document/${doc_id}`;
    try {
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Trigger signOut if 401 Unauthorized is received
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Refresh! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };
  const handleRetry = () => {
    setTimeOutPopUp(false);
    fetchData(value);
  };
  const getall_msg = async (conversationId) => {
    const accessToken = localStorage.getItem("accessToken");
    const skip = 0;
    const limit = 0;
    const forChat = false;
    const API_URL = `${
      import.meta.env.VITE_API_URL
    }/messages?conversation_id=${conversationId}&skip=${skip}&limit=${limit}&for_chat=${forChat}`;

    try {
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Trigger signOut if 401 Unauthorized is received
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Refresh! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  const stopChatstream = async () => {
    setUserStop(true);
    setLoading(false);
    setEditGeneration(false);
    if (ParentStore?.stopMessageId)
      await deleteMessage(ParentStore?.stopMessageId, { is_deleted: true });
    if (abortControllerRef?.current) abortControllerRef?.current?.abort();
    ParentStore?.setStopMessageId("");
    if (callDoneRef?.current === false) {
      callDoneRef.current = true;
    }

    const updatedMessages = [...messages];
    for (let i = updatedMessages.length - 1; i >= 0; i--) {
      if (updatedMessages[i].displayName === "userprompt") {
        updatedMessages[i] = {
          ...updatedMessages[i],
          stoppedByUser: true,
        };
        break;
      }
    }

    setmessages(updatedMessages);
  };

  const saveResponseTime = async (messageId: string, responseTime: number) => {
    try {
      const payload = {
        message_id: messageId || "",
        response_time: responseTime,
      };
      await updateMessageResponseTime(payload);
    } catch (error) {
      console.error("Error saving response time:", error);
    }
  };

  return (
    <Box>
      <Greenbanner
        name="Project Alchemist"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1000,
        }}
      />
      {covloader && (
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "120%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            backdropFilter: "blur(5px)",
            zIndex: 1000,
          }}
        >
          <Typography variant="h3">Uploading Documents...</Typography>
          <CircularProgress />
        </Box>
      )}
      <Box className="scrollable-container">
        <Box sx={{ padding: "1rem" }}>
          <Button
            disabled={!chat_data}
            onClick={handlesavedashboard}
            variant="contained"
            sx={{
              textTransform: "capitalize",
              fontSize: "0.7rem",
            }}
          >
            Back to Dashboard
          </Button>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "80vh",
            backgroundColor: "#D9D9D9",
            display: "flex",
            flexDirection: "row",
            overflowY: "auto",
          }}
        >
          <Box
            className="left-section"
            sx={{
              width: "55%",
              backgroundColor: "white",
              margin: "0.5rem 0.5rem 1rem 0.5rem",
              borderRadius: "0.5rem",
              overflowY: "auto",
            }}
          >
            <Box sx={{ height: "100%", overflow: "auto" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  margin: "1rem",
                }}
              >
                <Box sx={{ width: "70%" }}>
                  {document_name?.trim() !== "" && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mt: 2,
                      }}
                    >
                      <Typography sx={{ fontWeight: "bold" }} variant="h4">
                        Document Name:
                      </Typography>
                      <Typography variant="h4">{document_name}</Typography>
                    </Box>
                  )}
                </Box>
                <Box
                  sx={{
                    width: "30%",
                    display: "flex",
                    flexDirection: "row-reverse",
                    gap: "0.5rem",
                    mb: "0.5rem",
                  }}
                >
                  <Button
                    disabled={
                      !chat_data ||
                      loadversion ||
                      user_edit ||
                      loading ||
                      covloader
                    }
                    onClick={handleSave}
                    startIcon={<SaveIcon />}
                    variant="contained"
                    sx={{ textTransform: "capitalize" }}
                  >
                    Save Version
                  </Button>
                  <Button
                    disabled={!chat_data || user_edit || loading || covloader}
                    onClick={handleEditClick}
                    startIcon={<EditOutlinedIcon />}
                    variant="contained"
                    sx={{ textTransform: "capitalize" }}
                  >
                    {isEditable ? "Show" : "Edit"}
                  </Button>
                </Box>
              </Box>
              <Box sx={{ margin: "1rem", overflow: "auto" }}>
                {chat_data && (
                  <>
                    <DTable
                      setchat_data={setchat_data}
                      isEditable={isEditable}
                      data1={chat_data}
                    />
                    {citations?.length != 0 && (
                      <>
                        {!isApiError && !isTimeoutError && (
                          <div className="font-bold ">Sources</div>
                        )}
                        <ul>
                          {citations?.map((citation, index) => (
                            <li key={index}>
                              <Button
                                variant="outlined"
                                startIcon={<Article />}
                                sx={{
                                  textTransform: "none",
                                  margin: "0.2rem 0 0.2rem 0",
                                }}
                              >
                                <Sheet>
                                  <SheetTrigger>
                                    {citation?.source?.split("/").at(-1)}
                                  </SheetTrigger>
                                  <SheetContent style={{ maxWidth: "50vw" }}>
                                    <SheetHeader>
                                      <SheetTitle>
                                        {citation?.source?.split("/").at(-1)}
                                      </SheetTitle>
                                      <SheetDescription>
                                        <div className="font-semibold">
                                          {citation?.pages &&
                                            `page no. ${citation?.pages?.toString()}`}
                                        </div>
                                        <PDFViewer gcsPath={citation?.source} />
                                      </SheetDescription>
                                    </SheetHeader>
                                  </SheetContent>
                                </Sheet>
                              </Button>{" "}
                              {citation?.pages?.at(0)?.length !== 0 &&
                                `(p. ${citation?.pages?.toString()})`}
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </>
                )}
                {!chat_data && !isApiError && <LinearColor />}
                {!chat_data && isApiError && <ApiErrorDisplay />}
              </Box>
            </Box>
          </Box>
          <Box
            className="right-section"
            sx={{ width: "45%", margin: "0.5rem 0.5rem 1rem 0.5rem" }}
          >
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "white",
                  height: "80%",
                  width: "100%",
                  borderRadius: "0.5rem",
                  overflowY: "auto",
                }}
              >
                {messages[0] ? (
                  <ChatContainer
                    loadversion={loadversion}
                    setloadversion={setloadversion}
                    setGcs_generated_documents={setGcs_generated_documents}
                    setVersion={setVersion}
                    messages={messages}
                    isloading={loading}
                    handlesetchat={handlesetchat}
                    sdata={[
                      conversation_id,
                      value,
                      getParentLabel(value.section),
                    ]}
                    handlealldocs={handlealldocs}
                    user_edit={user_edit}
                    msgloadtext={msgloadtext}
                    covloader={covloader}
                    citations={citations}
                    isApiError={isApiError}
                    isTimeoutError={isTimeoutError}
                    responseTime={responseTime}
                  />
                ) : (
                  <>
                    <Msgloader />
                    <div className="ml-2">
                      {elapsedTime !== null && (
                        <Spinner elapsedTime={elapsedTime} />
                      )}
                    </div>
                  </>
                )}
              </Box>
              <TextField
                placeholder="Prompt goes here..."
                variant="outlined"
                disabled={!chat_data || loading || user_edit || covloader}
                value={question}
                onChange={sendquestion}
                multiline
                rows={3}
                sx={{
                  borderRadius: "0.5rem",
                  flexGrow: 1,
                  "& .MuiOutlinedInput-root": {
                    height: "100%",
                  },
                  "& textarea": {
                    height: "inherit !important",
                  },
                  backgroundColor: "white",
                  maxWidth: "100%",
                  overflowY: "auto",
                }}
                InputProps={{
                  style: {
                    fontSize: "large",
                    padding: "0.5rem",
                    height: "100%",
                  },
                  endAdornment: (
                    <>
                      {editGeneration ? (
                        <IconButton
                          disabled={!ParentStore?.stopMessageId}
                          sx={{
                            fontSize: "2rem",
                            backgroundColor: "#bcedaf",
                          }}
                          onClick={stopChatstream}
                        >
                          <StopCircle fontSize="inherit" />
                        </IconButton>
                      ) : (
                        <IconButton
                          disabled={
                            !chat_data || !question || user_edit || covloader
                          }
                          onClick={handleuserinput}
                          sx={{ fontSize: "2rem", backgroundColor: "#bcedaf" }}
                        >
                          <ArrowUpwardOutlinedIcon fontSize="inherit" />
                        </IconButton>
                      )}
                    </>
                  ),
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    handleuserinput();
                  }
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box flex="0 0 auto" sx={{ padding: "0.5rem 1rem" }}>
        <Footer
          document_name={document_name}
          setdocument_name={setdocument_name}
          isEditable={isEditable}
          covloader={covloader}
          loading={loading}
          setLoading={setLoading}
          setcovloader={setcovloader}
          parentgenerate={parentgenerate}
          secondcall={secondcall}
          version={version}
          setVersion={setVersion}
          data1={chat_data}
          button={showButtons}
          conversation_id={conversation_id}
          value={value}
          alldocs={alldocs}
          handlesetchat={handlesetchat}
          setsave_dashboard={setsave_dashboard}
          save_dashboard={save_dashboard}
          gcs_generated_documents={gcs_generated_documents}
          setGcs_generated_documents={setGcs_generated_documents}
          user_edit={user_edit}
          citations={citations}
          responseTime={responseTime}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            zIndex: 1000,
          }}
        />
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 1,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <br />
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <div style={{ width: "30rem" }}>
                  <Typography variant="normal" sx={{ fontSize: "1rem" }}>
                    Make sure you have saved your document,or else it will be
                    lost. Are you sure you want to proceed?
                  </Typography>
                  <br />
                  <br />
                </div>
              </FormControl>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              gap: "1rem",
              width: "100%",
            }}
          >
            <Button
              onClick={handledialog}
              variant="contained"
              autoFocus
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              Proceed
            </Button>
            <Button
              onClick={handleClose}
              variant="contained"
              autoFocus
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              No
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={timeoutPopUp}
        onClose={handleTimeoutPopUpClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={handleTimeoutPopUpClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 1,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <br />
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <div style={{ width: "30rem" }}>
                  <Typography variant="normal" sx={{ fontSize: "1rem" }}>
                    Sorry, something went wrong while processing your request.
                    Try again.
                  </Typography>
                  <br />
                  <br />
                </div>
              </FormControl>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              gap: "1rem",
              width: "100%",
            }}
          >
            <Button
              onClick={handleRetry}
              variant="contained"
              autoFocus
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              Try Again
            </Button>
            <Button
              onClick={() => navigate("/dashboard")}
              variant="contained"
              autoFocus
              sx={{ backgroundColor: "#137d00", textTransform: "capitalize" }}
            >
              Back To Dashboard
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Generate_Parent;
